const state = {
  currentStudent: undefined,
  getCurrentStudentName: ''
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/students/state.js